import variables from '../../variables.module.scss';

const MuiAppBar = (breakpoints) => ({
  styleOverrides: {
    root: {
      backgroundColor: variables.appBarBackgroundColor,
      minHeight: '128px',
      [breakpoints.down('customheadermobile')]: {
        minHeight: '60px',
      },
    },
  },
});

export default MuiAppBar;
